"use strict";
window.APP = window.APP || {};
APP.LabelCustomizationView = Backbone.View.extend({
  template: _.template($("#screen4Template").html()),
  initialize: function (options) {
    // access your data here
    this.brandid = options.brandid;
    if (this.brandid == 0) {
      this.brandid = 1;
    }
  },
  // populate the html to the dom
  render: function () {
    this.$el.html(this.template({ brandid: this.brandid }));
    return this;
  },
});
